import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { DefaultImageBaseurl, endPoints } from "../../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  fetchAllData,
} from "../../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../../redux/Actions/Actions";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import PageHeader from "../../../components/PageHeader";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import { AiTwotoneEyeInvisible, AiFillEyeInvisible } from "react-icons/ai";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment-timezone";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";

import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import DeleteModel from "../../../components/DeleteModel";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Chip from "@mui/material/Chip";
import OutlinedInput from "@mui/material/OutlinedInput";
import SearchIcon from "@mui/icons-material/Search";
import { uploadHeaders } from "../../../Utility/axiosInstances";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

// casino_games.defaultbet / minimumbet / maximumbet are nullable: leaving a field
// blank stores NULL, which means the game has no configured limit and the pre-bet
// range check skips it, which is what the blank-field placeholders say.

const Games = () => {
  const [editData, setEditData] = useState({});
  const [createData, setCreateData] = useState(false);
  const [rowDataToDelete, setRowDataToDelete] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [providerName, setProviderName] = useState("");
  const [gameId, setGameId] = useState("");
  const [gameName, setGameName] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [gameCreative, setGameCreative] = useState("");
  const [showGameCreative, setShowGameCreative] = useState(null);
  const [listMenu, setListMenu] = useState(null);
  const [featureCreative, setFeatureCreative] = useState("");
  const [showFeatureCreative, setShowFeatureCreative] = useState(null);
  const [menuSort, setMenuSort] = useState(null);
  const [wagerBack, setWagerBack] = useState(null);
  const [externalUrl, setExternalUrl] = useState(null);
  const [category, setCategory] = useState(null);
  const [defaultBet, setDefaultBet] = useState("");
  const [minimumBet, setMinimumBet] = useState("");
  const [maximumBet, setMaximumBet] = useState("");
  const [categoryid, setCategoryId] = useState(null);

  const [providerList, setProviderList] = useState([]);
  const [menuList, setMenuList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [playerList, setPlayerList] = useState([]);
  const [excludePlayerTypes, setExcludePlayerTypes] = useState([]);
  const [checkboxes, setCheckboxes] = useState({
    isCheckedGold: false,
    isCheckedSaga: false,
    isCheckedActive: false,
    isCheckedTop: false,
    isCheckedNew: false,
    isCheckedAllow: false,
    isExclusive:false
  });
  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [name]: checked,
    }));
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setGameCreative(file);
      setShowGameCreative(imageUrl);
      UploadGameCreativeImage(file);
    }
  };

  const handleFileChange1 = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setFeatureCreative(file);
      setShowFeatureCreative(imageUrl);
      UploadFeatureCreativeImage(file);
    }
  };

  const UploadGameCreativeImage = (files) => {
    var formdata = new FormData();
    formdata.append("file", files);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
      headers: uploadHeaders(),
    };
    setIsLoading(true);
    let imgUrl = `${endPoints.apiBaseUrl}${endPoints.api.UPLOAD_BANNER}`;
    fetch(imgUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setGameCreative(result.data);
        setIsLoading(false);
      })
      .catch((error) => console.log("error", error));
  };
  const UploadFeatureCreativeImage = (files) => {
    var formdata = new FormData();
    formdata.append("file", files);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
      headers: uploadHeaders(),
    };
    setIsLoading(true);
    let imgUrl = `${endPoints.apiBaseUrl}${endPoints.api.UPLOAD_BANNER}`;
    fetch(imgUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setFeatureCreative(result.data);
        setIsLoading(false);
      })
      .catch((error) => console.log("error", error));
  };

  const [pending, setPending] = useState(true);
  const [show, setShow] = useState(false);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClose = () => setShow(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchGameList();
    fetchProviderList();
    fetchMenuList();
    fetchGameCategory();
    getPlayerTypes();
  }, []);

  const getPlayerTypes = () => {
    let url = `${endPoints.api.playertypes}`;
    getAllData(url)
      .then((response) => {
        if (response.status === "success") {
          setPlayerList(response.data);
        }
      })
      .catch((err) => console.error("Error fetching player types:", err));
  };

  const handlePlayerTypeChange = (playerId) => {
    setExcludePlayerTypes((prev) =>
      prev.includes(playerId)
        ? prev.filter((id) => id !== playerId)
        : [...prev, playerId]
    );
  };

  const fetchGameList = async () => {
    let url = `${endPoints.api.GETGAMES}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          setRows(response.data);

          setPending(false);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const fetchProviderList = async () => {
    let url = `${endPoints.api.GETPROVIDERS}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          setProviderList(response.data);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };
  const fetchMenuList = async () => {
    let url = `${endPoints.api.GETMENU}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          setMenuList(response.data);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  
  const fetchGameCategory = async () => {
    let url = `${endPoints.api.GAME_CATEGORY}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          setCategoryList(response.data);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const handleOk = () => {
    //gameCreative
    //featureCreative
    if (
      providerName &&
      gameName &&
      apiKey &&
      listMenu &&
      menuSort &&
      wagerBack
    ) {
      let url = editData?.id
        ? `${endPoints.api.UPDATEGAMES}`
        : `${endPoints.api.ADDGAMES}`;

      const toBet = (value) =>
        value === "" || value === null || value === undefined
          ? null
          : Number(value);

      const bet = {
        defaultbet: toBet(defaultBet),
        minimumbet: toBet(minimumBet),
        maximumbet: toBet(maximumBet),
      };

      // Only the fields the admin actually filled in are checked against each
      // other; a null is an unset limit, not a zero.
      if (
        Object.values(bet).some(
          (v) => v !== null && (!Number.isFinite(v) || v < 0)
        )
      ) {
        ErrorToast("Bet amounts must be positive numbers");
        return;
      }
      if (
        bet.minimumbet !== null &&
        bet.maximumbet !== null &&
        bet.minimumbet > bet.maximumbet
      ) {
        ErrorToast("Minimum bet cannot be greater than maximum bet");
        return;
      }
      if (
        bet.defaultbet !== null &&
        ((bet.minimumbet !== null && bet.defaultbet < bet.minimumbet) ||
          (bet.maximumbet !== null && bet.defaultbet > bet.maximumbet))
      ) {
        ErrorToast("Default bet must be between the minimum and maximum bet");
        return;
      }

      let payload = {
        game_id: gameId,
        provider: providerName,
        game_name: gameName,
        game_creative: gameCreative,
        apikey: apiKey,
        menu: listMenu,
        feature_creative: featureCreative,
        menu_sort_order: menuSort,
        wager_rewards: wagerBack,
        goldcoin: checkboxes.isCheckedGold,
        sagacoin: checkboxes.isCheckedSaga,
        isactive: checkboxes.isCheckedActive,
        isexclusive:checkboxes.isExclusive,
        is_top: checkboxes.isCheckedTop,
        is_new: checkboxes.isCheckedNew,
        isallow_rewards: checkboxes.isCheckedAllow,
        ext_url: externalUrl,
        category:category,
        cat_id:categoryid,
        exclude_player: excludePlayerTypes,
        ...bet,
      };

      if (editData?.id) {
        payload.id = editData.id;
      }
      setIsLoading(true);
      addData(url, payload)
        .then((response) => {
          setIsLoading(false);
          if (response.data.status === "success") {
            SuccesToast(response?.data?.message);
            handleClose();
            fetchGameList();
          
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error(error);
          ErrorToast(error);
        });
    } else {
      ErrorToast("All fields are required");
    }
  };

  useEffect(() => {
    if (editData) {
      // console.log(editData );
      setProviderName(editData.provider || "");
      setGameId(editData.game_id || "");
      setGameName(editData.game_name || "");
      setCategory(editData.category || "");
      setGameCreative(editData.game_creative || "");
      let gameCreativeFullPath =
        editData.game_creative !== undefined
          ? `${DefaultImageBaseurl}${editData.game_creative}`
          : "";
      setShowGameCreative(gameCreativeFullPath || "");
      setApiKey(editData.apikey || "");
      setListMenu(editData.menu || "");
      setFeatureCreative(editData.feature_creative || "");
      let featureCreativeFullPath =
        editData.feature_creative !== undefined
          ? `${DefaultImageBaseurl}${editData.feature_creative}`
          : "";
      setShowFeatureCreative(featureCreativeFullPath || "");
      setMenuSort(editData.menu_sort_order || "");
      setWagerBack(editData.wager_rewards || "");
      setCategoryId(editData.cat_id || "");
      setCheckboxes((prevCheckboxes) => ({
        ...prevCheckboxes,
        isCheckedGold: editData.goldcoin || false,
        isCheckedSaga: editData.sagacoin || false,
        isCheckedActive: editData.isactive || false,
        isCheckedTop: editData.is_top || false,
        isCheckedNew: editData.is_new || false,
        isCheckedAllow: editData.isallow_rewards || false,
        isExclusive:editData?.isexclusive || false,
      }));
      setExternalUrl(editData?.ext_url || null);
      setExcludePlayerTypes(editData?.exclude_player || []);
      setDefaultBet(editData?.defaultbet ?? "");
      setMinimumBet(editData?.minimumbet ?? "");
      setMaximumBet(editData?.maximumbet ?? "");
    }
  }, [editData]);

  const handleDelete = (row) => {
    setRowDataToDelete(row);
    setShowDeleteModal(true);
  };

  const deleteGames = (row) => {
    const id = rowDataToDelete.id;

    let url = `${endPoints.api.DELETE_GAMES}${id}`;
    setIsLoading(false);
    deleteData(url)
      .then((response) => {
        console.log("update_Res", response);
        setIsLoading(false);
        if (response.status == 200) {
          fetchGameList();
          setShowDeleteModal(false);
          SuccesToast("Deleted Successfully");
        } else {
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  const handleSwitchChange = (row, param, value) => {
    const updatedRow = { ...row, [param]: value === false ? true : false };
    updateGames(updatedRow);
  };

  const updateGames = (payload) => {
    const id = payload.id;
    let url = `${endPoints.api.UPDATEGAMES}`;
    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          fetchGameList();
          handleClose();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  // Game Filter
  const [filteredRows, setFilteredRows] = useState(rows);
  const [filterValue, setFilterValue] = useState("");

  const handleFilterChange = (event) => {
    const newFilterValue = event.target.value.toLowerCase();
    setFilterValue(newFilterValue);

    if (newFilterValue === "") {
      setFilteredRows(rows);
    } else {
      const filteredData = rows.filter(
        (item) =>
          item.game_id.toLowerCase().includes(newFilterValue) ||
          item.provider.toLowerCase().includes(newFilterValue) ||
          item.game_name.toLowerCase().includes(newFilterValue)
      );
      setFilteredRows(filteredData);
    }
  };

  const getMenuName = (menuId) => {
    let menuName = menuList?.filter((item) => item.id == menuId) || menuId;
    return menuName ? menuName[0]?.menu_title : menuName;
  };

  const rowsToDisplay = [...(filterValue.length > 0 ? filteredRows : rows)].sort(
    (a, b) =>
      (Number(a.menu_sort_order) || 0) - (Number(b.menu_sort_order) || 0)
  );

  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        <DeleteModel
          showModal={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onDelete={deleteGames}
        />
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <PageHeader title="Games" crumb="Casino / Games" />

              <div style={{ marginTop: "10px" }}>
                <div className="table_search">
                  <TextField
                    // style={{ marginBottom: "10px", width: "25%" }}
                    placeholder="Enter game name or provider..."
                    type="text"
                    onChange={handleFilterChange}
                    value={filterValue}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                    style={{ width: "300px" }}
                  />
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        // aria-label="a dense table"
                        stickyHeader
                        // aria-label="sticky table"
                        sx={{ minWidth: 500 }}
                        aria-label="custom pagination table sticky table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Game ID</TableCell>
                            <TableCell align="center">Provider</TableCell>
                            <TableCell align="center">Game Name</TableCell>
                            <TableCell align="center">Game Category</TableCell>
                            <TableCell align="center">Game Creative</TableCell>
                            <TableCell align="center">
                              Feature Creative
                            </TableCell>
                            <TableCell align="center">RTP</TableCell>
                            <TableCell align="center">Sort Order</TableCell>
                            {/* <TableCell align="center">Gold Coins</TableCell>
                            <TableCell align="center">Saga Coins</TableCell> */}
                            <TableCell align="center">Exclusive Game</TableCell>
                            <TableCell align="center">Active</TableCell>
                            {/* <TableCell align="center">Top Games</TableCell>
                            <TableCell align="center">New Games</TableCell>
                            <TableCell align="center">Allow Rewards</TableCell> */}
                            <TableCell align="center">Options</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowsToDisplay
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row) => (
                              <TableRow
                                key={row.id}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell align="center">
                                  {row.game_id}
                                </TableCell>
                                <TableCell align="center">
                                  {row.provider}
                                </TableCell>
                                <TableCell align="center">
                                  {row.game_name}
                                </TableCell>
                                <TableCell align="center">
                                  {row?.category}
                                </TableCell>
                                <TableCell align="center">
                                  <img
                                    src={
                                      /^https?:\/\//.test(row.game_creative)
                                        ? row.game_creative
                                        : `${DefaultImageBaseurl}${row.game_creative}`
                                    }
                                    style={{ height: "50px" }}
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  <img
                                    src={
                                      /^https?:\/\//.test(row.feature_creative)
                                        ? row.feature_creative
                                        : `${DefaultImageBaseurl}${row.feature_creative}`
                                    }
                                    style={{ height: "50px" }}
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  {row.apikey}
                                </TableCell>

                                <TableCell align="center">
                                  {row.menu_sort_order}
                                </TableCell>
                                {/* <TableCell align="center">
                                  <Switch
                                    checked={row.goldcoin}
                                    onChange={() =>
                                      handleSwitchChange(
                                        row,
                                        "goldcoin",
                                        row.goldcoin
                                      )
                                    }
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  <Switch
                                    checked={row.sagacoin}
                                    onChange={() =>
                                      handleSwitchChange(
                                        row,
                                        "sagacoin",
                                        row.sagacoin
                                      )
                                    }
                                  />
                                </TableCell> */}

                                <TableCell align="center">
                                  <Switch
                                    checked={row.isexclusive}
                                    onChange={() =>
                                      handleSwitchChange(
                                        row,
                                        "isexclusive",
                                        row.isexclusive
                                      )
                                    }
                                  />
                                </TableCell>

                                <TableCell align="center">
                                  <Switch
                                    checked={row.isactive}
                                    onChange={() =>
                                      handleSwitchChange(
                                        row,
                                        "isactive",
                                        row.isactive
                                      )
                                    }
                                  />
                                </TableCell>
                                {/* <TableCell align="center">
                                  <Switch
                                    checked={row.is_top}
                                    onChange={() =>
                                      handleSwitchChange(
                                        row,
                                        "is_top",
                                        row.is_top
                                      )
                                    }
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  <Switch
                                    checked={row.is_new}
                                    onChange={() =>
                                      handleSwitchChange(
                                        row,
                                        "is_new",
                                        row.is_new
                                      )
                                    }
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  <Switch
                                    checked={row.isallow_rewards}
                                    onChange={() =>
                                      handleSwitchChange(
                                        row,
                                        "isallow_rewards",
                                        row.isallow_rewards
                                      )
                                    }
                                  />
                                </TableCell> */}

                                <TableCell align="center">
                                  <EditIcon
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setShow(true);
                                      setCreateData(true);
                                      setEditData(row);
                                    }}
                                  />
                                  <DeleteIcon
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleDelete(row)}
                                  />
                                </TableCell>
                              </TableRow>
                            ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={12}
                              count={rowsToDisplay.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                  <>
                    <Modal
                      show={show}
                      onHide={handleClose}
                      size="lg"
                      centered
                      scrollable
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Manage Games</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="row">
                          <div className="col-md-4">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Provider Name </Form.Label>
                              <Form.Select
                                value={providerName}
                                onChange={(event) => {
                                  setProviderName(event.target.value);
                                }}
                              >
                                <option value="">Select Provider</option>
                                {providerList.map((item, index) => {
                                  return (
                                    <option value={item.provider_name}>
                                      {item.provider_name}
                                    </option>
                                  );
                                })}
                              </Form.Select>
                            </Form.Group>
                          </div>
                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="gameId">
                              <Form.Label>Game Id</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter Game Id"
                                value={gameId}
                                onChange={(event) => {
                                  setGameId(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="gameName">
                              <Form.Label>Game Name</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Game Name"
                                value={gameName}
                                onChange={(event) => {
                                  setGameName(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>

                          <div className="col-md-4">
                          <Form.Group className="mb-3" controlId="listMenu">
                              <Form.Label>Game Category </Form.Label>
                              <Form.Select
                                value={category}
                                // onChange={(event) => {
                                //   setCategory(event.target.value);
                                // }}
                                onChange={(event) => {
                                  const selectedCategory = categoryList?.find(
                                    (item) => item?.category == event.target.value
                                  );
                                  setCategory(event.target.value);
                                  setCategoryId(selectedCategory ? selectedCategory?.cat_id : "");
                                }}
                              >
                                <option value="">Select List</option>
                                {categoryList.map((item, index) => {
                                  return (
                                    <option value={item.category}>
                                      {item.category}
                                    </option>
                                  );
                                })}
                              </Form.Select>
                            </Form.Group>
                          </div>

                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label>Game Creative </Form.Label>
                              <Form.Control
                                type="file"
                                placeholder="Game Creative"
                                onChange={handleFileChange}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="apiData">
                              <Form.Label>
                                RTP (Only Editable by admin){" "}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="xxxxxxx...."
                                value={apiKey}
                                onChange={(event) => {
                                  setApiKey(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4" style={{ marginTop: "5%" }}>
                            <Form.Check
                              inline
                              style={{ marginTop: "15px" }}
                              label="Gold Coins"
                              name="isCheckedGold"
                              type={"checkbox"}
                              id={`inline-${"checkbox"}-1`}
                              onChange={handleCheckboxChange}
                              checked={checkboxes.isCheckedGold}
                            />
                            <Form.Check
                              inline
                              style={{ marginTop: "15px" }}
                              label="Saga Coins"
                              name="isCheckedSaga"
                              type={"checkbox"}
                              id={`inline-${"checkbox"}-2`}
                              onChange={handleCheckboxChange}
                              checked={checkboxes.isCheckedSaga}
                            />

                          <Form.Check
                              inline
                              style={{marginTop:"15px"}}
                              label="Exclusive game"
                              name="isExclusive"
                              type={"checkbox"}
                              id={`inline-${"checkbox"}-3`}
                              onChange={handleCheckboxChange}
                              checked={checkboxes.isExclusive}
                            />

                          </div>
                          <div className="col-md-4">
                            {showGameCreative && (
                              <div>
                                <img
                                  src={showGameCreative}
                                  alt="Selected"
                                  style={{ maxWidth: "100px" }}
                                />
                              </div>
                            )}
                          </div>
                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="listMenu">
                              <Form.Label>List in Menu </Form.Label>
                              <Form.Select
                                value={listMenu}
                                onChange={(event) => {
                                  setListMenu(event.target.value);
                                }}
                              >
                                <option value="">Select List</option>
                                {menuList.map((item, index) => {
                                  return (
                                    <option value={item.id}>
                                      {item.menu_title}
                                    </option>
                                  );
                                })}
                              </Form.Select>
                            </Form.Group>
                          </div>
                          <div className="col-md-4" style={{ marginTop: "5%" }}>
                            <Form.Check
                              inline
                              label="Active"
                              name="isCheckedActive"
                              type={"checkbox"}
                              id={`inline-${"checkbox"}-3`}
                              onChange={handleCheckboxChange}
                              checked={checkboxes.isCheckedActive}
                            />
                            <Form.Check
                              inline
                              label="Top"
                              name="isCheckedTop"
                              type={"checkbox"}
                              id={`inline-${"checkbox"}-4`}
                              onChange={handleCheckboxChange}
                              checked={checkboxes.isCheckedTop}
                            />
                            <Form.Check
                              inline
                              label="New"
                              name="isCheckedNew"
                              type={"checkbox"}
                              id={`inline-${"checkbox"}-5`}
                              onChange={handleCheckboxChange}
                              checked={checkboxes.isCheckedNew}
                            />
                          </div>
                          <div className="col-md-4">
                            <Form.Group
                              className="mb-3"
                              controlId="featureGame"
                            >
                              <Form.Label>Feature Creative </Form.Label>
                              <Form.Control
                                type="file"
                                placeholder="Feature Creative"
                                onChange={handleFileChange1}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="menuSort">
                              <Form.Label>Menu Sort order</Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="100"
                                value={menuSort}
                                onChange={(event) => {
                                  setMenuSort(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4">
                            <FormGroup style={{ marginTop: "12%" }}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name="isCheckedAllow"
                                    checked={checkboxes.isCheckedAllow}
                                    onChange={handleCheckboxChange}
                                  />
                                }
                                label="Allow Rewards"
                              />
                            </FormGroup>
                          </div>
                          <div className="col-md-4">
                            {showFeatureCreative && (
                              <div>
                                <img
                                  src={showFeatureCreative}
                                  alt="Selected"
                                  style={{ maxWidth: "100px" }}
                                />
                              </div>
                            )}
                          </div>

                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="wagerBack">
                              <Form.Label>External Url</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="external Url"
                                value={externalUrl}
                                onChange={(event) => {
                                  setExternalUrl(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="wagerBack">
                              <Form.Label>
                                Wager Back Rewards Rate Override{" "}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="xxxxx"
                                value={wagerBack}
                                onChange={(event) => {
                                  setWagerBack(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>

                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="defaultBet">
                              <Form.Label>Default Bet (optional)</Form.Label>
                              <Form.Control
                                type="number"
                                min="0"
                                step="any"
                                placeholder="Not set"
                                value={defaultBet}
                                onChange={(event) => {
                                  setDefaultBet(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="minimumBet">
                              <Form.Label>Minimum Bet (optional)</Form.Label>
                              <Form.Control
                                type="number"
                                min="0"
                                step="any"
                                placeholder="No limit"
                                value={minimumBet}
                                onChange={(event) => {
                                  setMinimumBet(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="maximumBet">
                              <Form.Label>Maximum Bet (optional)</Form.Label>
                              <Form.Control
                                type="number"
                                min="0"
                                step="any"
                                placeholder="No limit"
                                value={maximumBet}
                                onChange={(event) => {
                                  setMaximumBet(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>

                          <div className="col-md-12" style={{ marginTop: "10px" }}>
                            <Form.Label style={{ fontWeight: "bold" }}>
                              Exclude Player Type
                            </Form.Label>
                            <FormControl fullWidth size="small">
                              <Select
                                multiple
                                displayEmpty
                                value={excludePlayerTypes}
                                onChange={(e) =>
                                  setExcludePlayerTypes(
                                    typeof e.target.value === "string"
                                      ? e.target.value.split(",")
                                      : e.target.value
                                  )
                                }
                                input={<OutlinedInput />}
                                renderValue={(selected) => {
                                  if (!selected || selected.length === 0) {
                                    return (
                                      <span style={{ color: "#5a6180" }}>
                                        Select player types to exclude
                                      </span>
                                    );
                                  }
                                  return (
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                                      {selected.map((id) => {
                                        const p = playerList.find((x) => x.id === id);
                                        return (
                                          <Chip
                                            key={id}
                                            size="small"
                                            label={p ? p.player_type : id}
                                          />
                                        );
                                      })}
                                    </div>
                                  );
                                }}
                                MenuProps={{
                                  PaperProps: { style: { maxHeight: 320 } },
                                  sx: { zIndex: 1600 },
                                }}
                              >
                                {playerList.map((player) => (
                                  <MenuItem key={player.id} value={player.id}>
                                    <Checkbox
                                      checked={excludePlayerTypes.includes(player.id)}
                                    />
                                    <ListItemText primary={player.player_type} />
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          onClick={handleOk}
                          style={{
                            background: "#04631e",
                            borderColor: "#04631e",
                          }}
                        >
                          Apply
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginTop: "20px",
                }}
              >
                <Button
                  variant="primary"
                  style={{ background: "#04631e", borderColor: "#04631e" }}
                  onClick={() => {
                    setShow(true);
                    setCreateData(true);
                    setShowGameCreative(null);
                    setShowFeatureCreative(null);
                    setEditData({});
                  }}
                >
                  Add New Game
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Games;
